import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { Helpers } from '../../../helpers';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrdersService } from '../../services/orders/orders.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { TranslateConfigService } from '../../../../app/theme/home/translateConfig.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../../app/auth/_services/encrypt-decrypt.pipe';
import { Observable } from 'rxjs';
const LNG_KEY = "SELECTED_LANGUAGE";
declare var google: any;

@Component({
  selector: 'app-new-rate-history',
  templateUrl: './new-rate-history.component.html',
  styleUrls: ['./new-rate-history.component.scss']
})
export class NewRateHistoryComponent implements OnInit {

  tableDetails: ITableModel;
  TripHistoryfororders: any = [];
  ExpenseBifurcation: any = [];
  @ViewChild("ExpenseBifurcationComponent") ExpenseBifurcationComponent: TemplateRef<any>;
  @ViewChild("AssignVehicle") AssignVehicle: TemplateRef<any>;
  @Input () FromCity:any;
  @Input () ToCity:any;
  @Input () VehicleTypeName:any;
  static that: NewRateHistoryComponent;
  modalRef: any;
  TransationType: any;
  Id: any;
  noOfPages: number = 15;
  TenantId: any;
  CompanyId: any;
  userId: any;
  bookingData: any = {};
  TransportServiceList: any;
  IsAssignvehicleSaveDisable: any = false;
  ValidateTHCADvanceAmountFlag: boolean = false;
  courierListIds: any = [];
  CourierList: any = [];
  ManualvehicleOrderList: any = [];
  ManualvehicleOrderDetail = [];
  ManualvehiclePlanning: any = {};
  isSTPBooking: any = false;
  ManualPlanningDestinationValuesFromPinCodeDeliveryBranchFlag = false;
  ordersData: any;
  CourierPackages: any = [];
  CourierDimentions: any = [];
  CourierAdditionalPack: any = [];
  TransportNames: any = [];
  OrderData: any = {};
  OrdersPackage: any = [];
  CourierRate: any = [];
  NetTotal: any = 0;
  TaxApplicableFlag: boolean = false;
  selectedLang: any;
  @Input() TransportService: any; // Added by priya - 07/04/2026 - cn(PRIYA-APR26-002)
  
  constructor(
    private _appService: appService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private orderService: OrdersService,
    private dp: DatePipe,
    private translate: TranslateService,
    private service: TranslateConfigService,
    private router: Router,
    private route: ActivatedRoute,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
  ) { 
    NewRateHistoryComponent.that = this;
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    this.TenantId = JSON.parse(
    this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const storedPerPage = localStorage.getItem('perPage');
    if (storedPerPage) {
      this.noOfPages = parseInt(storedPerPage, 10);
    }
    let rowData = localStorage.getItem('RowData');
    if (rowData) {
      this.ordersData = JSON.parse(rowData); 
    } else {
      console.error('No data found in localStorage for "RowData"');
    }
    this.ManualPlanningDestinationValuesFromPinCodeDeliveryBranchFlag =
    JSON.parse(
      localStorage.getItem(
        "ManualPlanningDestinationValuesFromPinCodeDeliveryBranchFlag"
      )
    );
    this.route.queryParamMap.subscribe((params) => {
      this.Id = params.get("id");
      this.TransationType = params.get("type");
      if (this.Id != null && this.Id != undefined && this.Id != "") {
        if (this.TransationType == 'FTL') {
          this.initiateCourierList(this.Id);
        }
        // if (this.TransationType == 'Country') {
        //   this.GetCourierRates();
        // }
        if (this.TransationType == 'Air') {
          this.initiateCourierList(this.Id);
        }
      }
    });
    this.BiddingList();
    this.GetTripHistoryfororders();
    this.GetTransportService();
  }

  async BiddingList() {
    this.tableDetails = {
      emptyDataMSg: "No Record Found",
      data: [],
      columnDetails: [
        { columnName: "Transporter", dataFieldName: "TransporterName",  dataFieldName2: 'Phone', dataFieldName3: 'Email', divType: 'UserDetails', isProduct: true },
        { columnName: 'Trip No', dataFieldName: 'FCNumber', },
        { columnName: "Booking Date", dataFieldName: "BookingDate" },
        { columnName: "Vehicle Type", dataFieldName: "VehicleType" },
        { columnName: "Amount", dataFieldName: "Amount" },
        { columnName: 'Action', dataFieldName: '', divType: 'NewShipAction' },
      ],
      actionList: [],
      isColumnNameShow: true,
    };
  }

  GetTripHistoryfororders() {
    this.TripHistoryfororders = [];
    var fromCity = this.ordersData.PickupCity
    var tocity = this.ordersData.DeliveryCity
    var vehicleTypes = this.ordersData.VehicleTypeName || this.ordersData.VehicleList[0].VehicleTypeName // Added by priya - 10/01/2026 - if vehicle typename is undefined then take from vehicle list
    this._appService.GetByThreeId('OrdersByVehicle', 'GetTripHistoryfororders', fromCity, tocity, vehicleTypes).subscribe(
      (response) => {
        console.log(response, 'GetTripHistoryfororders')
        this.TripHistoryfororders = response;
        this.tableDetails.data = response;
    
      },
      (err) => {
        this.toastr.error("Error occurred while fetching data !", "error");
      }
    );
  }

  goToDetailsPage(event){
    this.GetExpenseBifurcation(event.BookingId)
  }

  GetExpenseBifurcation(BookingId: any) {
    this.ExpenseBifurcation = [];
    this.modalRef = this.modalService.open(this.ExpenseBifurcationComponent);
    Helpers.setLoading(true)
    this._appService.GetByOneParam('OrdersByVehicle', 'GetExpenseBifurcation', BookingId).subscribe(
      (response) => {
        console.log(response, 'GetExpenseBifurcation')
        this.ExpenseBifurcation = response;
        Helpers.setLoading(false)
      },
      (err) => {
        this.toastr.error("Error occurred while fetching data !", "error");
        Helpers.setLoading(false)
      }
    );
  }

  GetTransportService() {
    this.orderService.GetTransportServiceList().then((res) => {
      this.TransportServiceList = res;
    })
    .catch((error) => {
      console.log(error);
    });
  }

  initiateCourierList(data: any) {
    this.courierListIds = data;
    var obj: any = {};
    obj.OrderId = this.courierListIds;

    this._appService.Post("OrdersByVehicle", "oc_GetCourierDataByIds", obj).subscribe(
    (response) => {
      this.CourierList = response.Table;
      this.CourierPackages = response.Table1;
      this.CourierDimentions = response.Table2;
      this.CourierAdditionalPack = response.Table4;
      this.OrdersPackage = response.Table5;

      var TransportName: any = [];
      this.CourierList.forEach((element) => {
        TransportName.push(element.TransportName);
      });
      this.TransportNames = Array.from(new Set(TransportName)).join(", ");

      this.OrderData.OrderCount = this.courierListIds.length;
      this.OrderData.SumOfQty = 0;
      this.OrderData.SumOfWeight = 0;
      this.OrderData.Volume = 0;
      this.OrderData.SumOFCFT = 0;

      this.CourierDimentions.forEach((element) => {
        this.OrderData.SumOfQty = this.OrderData.SumOfQty + element.Qty;
      });
      this.CourierPackages.forEach((element) => {
        this.OrderData.SumOFCFT = this.OrderData.SumOFCFT + element.CFT;
        this.OrderData.SumOfWeight =
          this.OrderData.SumOfWeight + element.weight;
        this.OrderData.Volume = this.OrderData.Volume + element.Volume;
      });

      if (this.TransationType != 'Air') {
        this.GetCourierRate();
      } else {
        this.OrderData.SumOfQty = 0;
        this.OrderData.SumOfWeight = 0;
        this.OrderData.SumOfDimension = 0;
        this.OrdersPackage.forEach((element) => {
          this.OrderData.SumOfQty = this.OrderData.SumOfQty + element.TotalPackages;
          this.OrderData.SumOfWeight = this.OrderData.SumOfWeight + element.GrossWeight;
          this.OrderData.SumOfDimension = this.OrderData.SumOfDimension + (element.Length + element.Width);
        });
      }

    },
    (err) => {
      this.toastr.error(
        "Error occurred while fetching Courier data !",
        "error"
      );
    });
  }

  async GetCourierRate() {
    const hasComma = this.courierListIds.includes(",");

    var obj: any = [];
    if (hasComma == false) {
      obj.push(this.courierListIds);
    } else {
      obj = this.courierListIds.split(",").map((item) => item.trim());
    }

    for (let i = 0; i < obj.length; i++) {
      await new Promise(async (resolve1, reject1) => {
        this._appService
          .GetByTwoId(
            "OrdersByVehicle",
            "oc_GetCourierRate",
            obj[i],
            this.CompanyId
          )
          .subscribe(
            (response) => {
              this.CourierRate = [];
              this.CourierRate = response;
              var SubTotal = 0;
              var totalSGST = 0;
              var totalCGST = 0;
              var totalIGST = 0;
              this.NetTotal = 0;
              this.CourierRate.forEach((element) => {
                SubTotal = SubTotal + element.ChargeRate;
                totalSGST =
                  totalSGST + element.ChargeRate * (element.SGST / 100);
                totalCGST =
                  totalCGST + element.ChargeRate * (element.CGST / 100);
                totalIGST =
                  totalIGST + element.ChargeRate * (element.IGST / 100);
              });
              SubTotal = parseFloat(SubTotal.toFixed(2));
              totalSGST = parseFloat(totalSGST.toFixed(2));
              totalCGST = parseFloat(totalCGST.toFixed(2));
              totalIGST = parseFloat(totalIGST.toFixed(2));

              if (this.TaxApplicableFlag == false) {
                this.NetTotal = parseFloat(SubTotal.toFixed(2));
                totalSGST = 0;
                totalCGST = 0;
                totalIGST = 0;
              } else {
                this.NetTotal = parseFloat(
                  (SubTotal + totalSGST + totalCGST + totalIGST).toFixed(2)
                );
              }
              resolve1("OK");
            },
            (err) => {
              this.toastr.error(
                "Error occurred while fetching courier rate data !",
                "error"
              );
              resolve1("OK");
            }
          );
      });
    }
  }

  ShipActionBtn(event){
    var difference = 0;
    console.log('this.TransportService.TransportName', this.TransportService.TransportName)
    if (this.TransationType == "FTL") {
      this.bookingData.VehicleType = event.row.VehicleTypeId
      this.bookingData.VehicleNo = event.row.RegistrationNo;
      this.bookingData.Transporter = event.row.TransporterId
      this.bookingData.TransporterName = event.row.TransporterName;
      this.bookingData.Driver = event.row.DriverName;
      this.bookingData.DriverName = event.row.Driver;
      this.bookingData.DriverCode = event.row.DriverCode;
      this.bookingData.DriverMobileNo = event.row.MobileNo;
      // commented and added by priya - 07/04/2026 - cn(PRIYA-APR26-002)
      // this.bookingData.TransportService = this.TransportServiceList.filter(
      //   (x) => x.Label === "FTL"
      // )[0].Id;
      let selectedService = this.TransportServiceList.find(
        (x: any) => x.Label === this.TransportService.TransportName
      );
      if (!selectedService) {
        selectedService = this.TransportServiceList.find((x: any) => x.Label === "FTL");
      }
      this.bookingData.TransportService = selectedService ? selectedService.Id : null;
      // end by priya
      this.bookingData.VehiclePlacementDate = this.dp.transform(new Date(), "dd-MMM-yyyy");
      this.bookingData.EstimatedDeliveryDate = this.dp.transform(new Date(), "dd-MMM-yyyy");
      this.bookingData.LeadTime = 0;
      this.bookingData.Advance = 0;
      // Added by priya - 23/06/2026 - cn(PRIYA-JUN26-008)
      this.bookingData.VehicleDistance = event.row.VehicleDistance;
      this.bookingData.VehicleTravelTime = event.row.VehicleTravelTime;
      this.bookingData.OrderPickupDate = event.row.OrderPickupDate;
      // End by priya
      console.log('event', this.bookingData)
    } else if (this.TransationType == 'ContainerMovement') {
      // Added and commented by priya - 07/04/2026 - cn(PRIYA-APR26-002)
      this.bookingData.VehicleType = event.row.VehicleTypeId;
      this.bookingData.VehicleNo = event.row.RegistrationNo;
      this.bookingData.Transporter = event.row.TransporterId
      this.bookingData.TransporterName = event.row.TransporterName;
      this.bookingData.Driver = event.row.DriverName;
      this.bookingData.DriverName = event.row.Driver;
      this.bookingData.DriverCode = event.row.DriverCode;
      this.bookingData.DriverMobileNo = event.row.MobileNo;
      let selectedService = this.TransportServiceList.find(
        (x: any) => x.Label === this.TransportService.TransportName
      );
      this.bookingData.TransportService = selectedService ? selectedService.Id : null;
      this.bookingData.VehiclePlacementDate = this.dp.transform(new Date(), "dd-MMM-yyyy");
      this.bookingData.EstimatedDeliveryDate = this.dp.transform(new Date(), "dd-MMM-yyyy");
      this.bookingData.LeadTime = 0;
      this.bookingData.Advance = 0;
      // Added by priya - 23/06/2026 - cn(PRIYA-JUN26-008)
      this.bookingData.VehicleDistance = event.row.VehicleDistance;
      this.bookingData.VehicleTravelTime = event.row.VehicleTravelTime;
      this.bookingData.OrderPickupDate = event.row.OrderPickupDate;
      // End by priya
      // end by priya
    } else if (this.TransationType == 'Air') {
      this.OnClickShipNow(event.row.ShortName, event.row.TransporterId, event.row.Transporter, event.row.LeadTime, event.row.service_code, event.row.Rate);
    } else {
      if (difference < 0) {
        this.toastr.info("Please Recharge to Confirm Order", "Info");
      } else {
        this.CreateConsignmentCountry(event.row.id, event.row.LeadTime);
      }
    }
    this.modalRef = this.modalService.open(this.AssignVehicle, {windowClass: 'assign-vehicle-modal',centered: false});
  }

  OnSaveAssignVehicle(event) {
    console.log(event, 'event')
      this.IsAssignvehicleSaveDisable = true;
      var obj: any = {};
      obj = event;
      const estimatedDate = new Date(obj.EstimatedDeliveryDate);
      const placementDate = new Date(obj.VehiclePlacementDate);
      if (estimatedDate <= placementDate && estimatedDate != placementDate) {
        this.toastr.error(this.translate.instant("PENDINGARRIVAL.PlacementDateValidation"), "Alert");
        this.IsAssignvehicleSaveDisable = false;
        return;
      }
      // if (obj.EstimatedDeliveryDate <= obj.VehiclePlacementDate && obj.EstimatedDeliveryDate != obj.VehiclePlacementDate) {
      //   this.toastr.error(this.translate.instant("PENDINGARRIVAL.PlacementDateValidation"), "Alert");
      //   this.IsAssignvehicleSaveDisable = false;
      //   return;
      // }
      if (this.ValidateTHCADvanceAmountFlag == true) {
        if (obj.Advance == 0 || obj.Advance == undefined || obj.Advance == null || obj.Advance == "") {
          var message = this.translate.instant("ALERTMESSAGES.AdvanceAmountShoubeGraterThanZero");
          this.toastr.error(message, "Alert");
          this.IsAssignvehicleSaveDisable = false;
          return;
        }
      }
  
      this.ManualvehicleOrderList = this.CourierList;
      var FinalDestination = this.ManualvehicleOrderList[0].DeliveryLocationCode;
      this._appService.GetByTwoId("Booking", "GetOrderAddressFromLocationCode", null, FinalDestination).subscribe(async (response) => {
        var DestinationLocation = "";
        DestinationLocation = response[0].DeliveryAddress;
        var DeliveryAddressUnique: any = [];
        var OrderInfo: any = [];
        var obj1: any = {};
        (obj1.origin = this.ManualvehicleOrderList[0].PickupAddress), (obj1.destination = response[0].DeliveryAddress);
        OrderInfo.push(obj1);
  
        this.ManualvehicleOrderList.map(function (item) {
          if (NewRateHistoryComponent.that.ManualPlanningDestinationValuesFromPinCodeDeliveryBranchFlag == true) {
            item.DeliveryAddress = response[0].DeliveryAddress;
          }
          var existItem = DeliveryAddressUnique.find((x) => x.location == item.DeliveryAddress);
          if (!existItem) {
            var obj: any = {};
            (obj.location = item.DeliveryAddress),
              (obj.stopover = true),
              (obj.Order = 0),
              (obj.RouteOrder = "A");
            DeliveryAddressUnique.push(obj);
          }
        });
  
        var DeliveryAddressUniqueResult: any = [];
        NewRateHistoryComponent.that.calculateRouteOptimization(OrderInfo, DeliveryAddressUnique).then(async (res) => {
          setTimeout(() => {
            DeliveryAddressUniqueResult = res;
            for (let i = 0; i < this.ManualvehicleOrderList.length; i++) {
              for (let j = 0; j < DeliveryAddressUniqueResult.length; j++) {
                if (
                  this.ManualvehicleOrderList[i].DeliveryAddress ==
                  DeliveryAddressUniqueResult[j].location
                ) {
                  this.ManualvehicleOrderList[i].RouteOrder =
                    DeliveryAddressUniqueResult[j].RouteOrder;
                }
              }
            }
  
            for (let i = 0; i < this.ManualvehicleOrderList.length; i++) {
              this.ManualvehicleOrderDetail[i] = {};
              this.ManualvehicleOrderDetail[i].OrderID = this.ManualvehicleOrderList[i].Id;
              this.ManualvehicleOrderDetail[i].PickupLocationCode = this.ManualvehicleOrderList[i].PickupLocationCode;
              this.ManualvehicleOrderDetail[i].DeliveryLocationCode = FinalDestination;
              if (this.isSTPBooking) {
                this.ManualvehicleOrderDetail[i].DeliveryLocationCode = this.ManualvehicleOrderList[i].DeliveryLocationCode;
              }
              this.ManualvehicleOrderDetail[i].Qty = this.ManualvehicleOrderList[i].Qty;
              this.ManualvehicleOrderDetail[i].OrderItemsId = this.ManualvehicleOrderList[i].OrderItemsId == undefined ? null : this.ManualvehicleOrderList[i].OrderItemsId;
              this.ManualvehicleOrderDetail[i].VehicleOrdersProductID = this.ManualvehicleOrderList[i].VehicleOrdersProductID == undefined ? null : this.ManualvehicleOrderList[i].VehicleOrdersProductID;
              this.ManualvehicleOrderDetail[i].RouteOrder = this.ManualvehicleOrderList[i].RouteOrder;
            }
  
            this.ManualvehiclePlanning.ManualvehicleOrderDetail = this.ManualvehicleOrderDetail;
            this.ManualvehiclePlanning.TransportServiceId = obj.TransportService;
            this.ManualvehiclePlanning.TransporterId = obj.Transporter;
            this.ManualvehiclePlanning.VehicleTypeID = obj.VehicleType;
            this.ManualvehiclePlanning.VehicleNo = obj.VehicleNo;
            this.ManualvehiclePlanning.DriverCode = obj.Driver;
            this.ManualvehiclePlanning.DriverMobileNo = obj.DriverMobileNo;
            this.ManualvehiclePlanning.VehiclePlacementDate = obj.VehiclePlacementDate;
            this.ManualvehiclePlanning.EstimatedDeliveryDate = obj.EstimatedDeliveryDate;
            this.ManualvehiclePlanning.BookingType = "primary"; //this.BookingType;
            this.ManualvehiclePlanning.BookingTypeAuto = null;
            this.ManualvehiclePlanning.LeadTime = obj.LeadTime;
            this.ManualvehiclePlanning.Advance = obj.Advance;
            // if (this.isSTPBooking) {
            //   this.ManualvehiclePlanning.BookingTypeAuto = this.STPModelListData[this.STPIdexId].BookingType;
            // }
            this.ManualvehiclePlanning.CompanyId = this.CompanyId;
            this.ManualvehiclePlanning.opa_userId = this.userId;
            this.ManualvehiclePlanning.Captain = null;
            this.ManualvehiclePlanning.IsFromRouteOptimization = false;
            this.ManualvehiclePlanning.RouteOptimization = true;
            this.ManualvehiclePlanning.PotterTripId = null;
            this.ManualvehiclePlanning.ChargeAmount = 0;
            this.ManualvehiclePlanning.IsFromManualPlanning = false;
            console.log('===========', this.ManualvehiclePlanning)
            NewRateHistoryComponent.that._appService.Post("ManualvehiclePlanning", "CreateBookingFromManualPlan", NewRateHistoryComponent.that.ManualvehiclePlanning).subscribe((response) => {
              this.IsAssignvehicleSaveDisable = false;
              if (response == true) {
                NewRateHistoryComponent.that.toastr.success("Booking Created Successfully !", "Success");
                NewRateHistoryComponent.that.modalRef.close();
                NewRateHistoryComponent.that.router.navigateByUrl(`/FtlList`);
              }
            },
              (err) => {
                NewRateHistoryComponent.that.toastr.error(err._body.replace(/"/g, ""), "Error");
                this.IsAssignvehicleSaveDisable = false;
              }
            );
          }, 2000);
        });
      },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
          this.IsAssignvehicleSaveDisable = false;
        }
      );
  }

  async calculateRouteOptimization(OrderInfoData, DestinationLocation): Promise<Observable<any>> {
    try {
      if (DestinationLocation.length > 1) {
        const directionsService = new google.maps.DirectionsService();
        const waypts = [];
        for (let i = 0; i < DestinationLocation.length; i++) {
          waypts.push({
            location: DestinationLocation[i].location,
            stopover: true,
          });
        }
        await directionsService.route(
          {
            origin: OrderInfoData[0].origin,
            destination: OrderInfoData[0].destination,
            waypoints: waypts,
            optimizeWaypoints: true,
            travelMode: google.maps.TravelMode.DRIVING,
          },
          (response, status) => {
            if (status === "OK") {
              let ViewPoints = [];
              ViewPoints = response.routes[0].waypoint_order;
              var mainNum = 65;
              var subNum = 63;
              for (let i = 0; i < ViewPoints.length; i++) {
                DestinationLocation[ViewPoints[i]].Order = i;
                DestinationLocation[ViewPoints[i]].RouteOrder =
                  subNum == 63
                    ? String.fromCharCode(mainNum)
                    : String.fromCharCode(mainNum) +
                    String.fromCharCode(subNum);
                if (mainNum == 90 || subNum == 90) {
                  mainNum = subNum == 63 ? 65 : mainNum + 1;
                  subNum = 64;
                }
                subNum = subNum == 63 ? subNum : subNum + 1;
                mainNum = subNum == 63 ? mainNum + 1 : mainNum;
              }
              // this.OrderDestinationLocation1=(DestinationLocation);
              // return this.OrderDestinationLocation1;
            } else {
              // window.alert("Directions request failed due to " + status);
            }
          }
        );
      }
    } catch (error) {
      return DestinationLocation;
    }
    return DestinationLocation;
  }

  async OnClickShipNow(ShortName, TransporterId, TransporterName, LeadTime, service_code, TotalRate) {
    for (let a = 0; a < this.courierListIds.length; a++) {
      await new Promise(async (resolve1, reject1) => {
        this._appService.GetById("OrdersByVehicle","oc_GetCourierDataByIdConsignment",NewRateHistoryComponent.that.courierListIds[a]).subscribe(
        (response) => {
          var obj: any = {};
          obj.OrderDetails = response.Table[0];
          obj.ProductDetails = response.Table1;
          obj.ProductDimentions = response.Table2;
          obj.InvoiceDetails = response.Table3;
          obj.AdditionalServices = response.Table4;
          obj.OrdersPackage = response.Table5;

          var ConsignmentList: any = [];
          ConsignmentList.push(obj);
          NewRateHistoryComponent.that.CreateConsignment(
            obj,
            ShortName,
            NewRateHistoryComponent.that.courierListIds[a],
            TransporterId,
            TransporterName,
            LeadTime,
            service_code,
            TotalRate
          );
          resolve1("OK");
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching data !",
            "error"
          );
          resolve1("OK");
        });
      });
    }
  }

  async CreateConsignment(
    a: any,
    TransporterShortName: any,
    OrderId: any,
    TransporterId: any,
    TransporterName: any,
    LeadTime: any,
    service_code: any,
    TotalRate: any
  ) {
    var data: any = {};

    data.consignment = {};
    data.consignment.consolidate = 'No'; //this.DiffLocations == true ? 'No' : 'Yes';
    data.consignment.shipper_company_code = a.OrderDetails.PickupLocationCode;
    data.consignment.consignment_number = '';
    data.consignment.is_draft = "No";
    data.consignment.from_challan_id = "";
    data.consignment.consignor_company_id = "";
    data.consignment.consignor_company_name = a.OrderDetails.ConsignorCompany;
    data.consignment.consignor_company_code = a.OrderDetails.ConsignorCode;
    data.consignment.consignor_facility_name = a.OrderDetails.PickupCity;
    data.consignment.consignor_facility_code = a.OrderDetails.PickupLocationCode;
    data.consignment.consignor_address_line1 = a.OrderDetails.ConsignerAddress;
    data.consignment.consignor_address_line2 = "";
    data.consignment.consignor_city = a.OrderDetails.ConsignerCity;
    data.consignment.consignor_state = a.OrderDetails.ConsignerState;
    data.consignment.consignor_pin = a.OrderDetails.ConsignerPincode;
    data.consignment.consignor_contact_name = a.OrderDetails.PickUpContactPerson;
    data.consignment.consignor_phone = a.OrderDetails.PickUpContactNumber;
    data.consignment.consignee_company_id = "";
    data.consignment.consignee_company_name = a.OrderDetails.ConsigneeName;
    data.consignment.consignee_company_code = a.OrderDetails.ConsigneeCode;
    data.consignment.consignee_facility_name = a.OrderDetails.DeliveryCity;
    data.consignment.consignee_facility_code = a.OrderDetails.DeliveryLocationCode;
    data.consignment.consignee_address_line1 = a.OrderDetails.ConsigneeAddress;
    data.consignment.consignee_address_line2 = "";
    data.consignment.consignee_city = a.OrderDetails.ConsigneeCity;
    data.consignment.consignee_state = a.OrderDetails.ConsigneeState;
    data.consignment.consignee_pin = a.OrderDetails.ConsigneePincode;
    data.consignment.consignee_contact_name = a.OrderDetails.DeliveryContactPerson;
    data.consignment.consignee_phone = a.OrderDetails.DeliveryContactNumber;
    data.consignment.reference_number_1 = a.OrderDetails.ReferenceNo;
    data.consignment.reference_number_2 = "";
    data.consignment.service_option = 'SURF XPRS'; //a.OrderDetails.TransportName;
    data.consignment.truck_category = "";
    data.consignment.service_provider_company_code = TransporterShortName;
    data.consignment.vehicle_number = "";
    data.consignment.driver_name = "";
    data.consignment.driver_mobile_number = "";
    data.consignment.volume = ""; //a.OrderDetails.Volume;
    data.consignment.volume_measure = "";
    data.consignment.ready_for_pickup_at = a.OrderDetails.PickupLocationCode;
    data.consignment.payment_mode = 'To Bill'; //a.OrderDetails.Freight;
    data.consignment.slot_date = "";
    data.consignment.slot_name = "";
    data.consignment.slot_company_code = "";
    data.consignment.weight = a.OrderDetails.Weight;
    data.consignment.billable_weight = a.OrderDetails.VolumetricWeight > a.OrderDetails.Weight == true ? a.OrderDetails.VolumetricWeight : a.OrderDetails.Weight;
    data.consignment.weight_measure = "Kgs";

    data.consignment.consignment_contents = {};
    data.consignment.consignment_contents.consignment_content = [];
    data.product_data = [];
    data.products = [];
    data.consignment_contents_common = {};
    data.consignment_contents_common.consignment_content_common = [];
    for (let k = 0; k < a.ProductDetails.length; k++) {
      var obj: any = {};

      obj.reference_number = a.OrderDetails.ReferenceNo; //ASK
      obj.delivery_number = null; //ASK
      obj.product_id = "";
      obj.product_name = 'OTHERS'; //a.ProductDetails[k].ProductName;
      obj.product_display_name = a.ProductDetails[k].ProductName;
      obj.units = a.ProductDetails[k].Qty;
      obj.unit_type = 'Units'; //a.ProductDetails[k].UnitName;
      obj.weight = a.ProductDetails[k].weight;
      obj.billable_weight = a.ProductDetails[k].VolumetricWeight > a.OrderDetails.Weight == true ? a.ProductDetails[k].VolumetricWeight : a.OrderDetails.Weight;
      obj.weight_measure = "Kgs";
      obj.length = a.ProductDetails[k].Length;
      obj.width = a.ProductDetails[k].Width;
      obj.height = a.ProductDetails[k].Height;
      obj.uom = 'inches'; //a.ProductDetails[k].UnitName;
      data.consignment.consignment_contents.consignment_content.push(obj);

      //************************************************************** */
      var obj2: any = {};
      obj2.hsnno = a.ProductDetails[k].HSNNo;
      obj2.product_name = a.ProductDetails[k].ProductName;

      var total = parseFloat(a.ProductDetails[k].Price) * parseFloat(a.ProductDetails[k].Qty);
      if (a.OrderDetails.ConsignerState == a.OrderDetails.ConsigneeState) {
        obj2.SGSTAmount = total * (9 / 100);
        obj2.CGSTAmount = total * (9 / 100);
        obj2.IGSTAmount = 0;
        obj2.GSTTaxRateCGSTN = 9;
        obj2.GSTTaxRateSGSTN = 9;
        obj2.GSTTAXRateIGSTN = 0;
      } else {
        obj2.SGSTAmount = 0;
        obj2.CGSTAmount = 0;
        obj2.IGSTAmount = total * (18 / 100);
        obj2.GSTTaxRateCGSTN = 0;
        obj2.GSTTaxRateSGSTN = 0;
        obj2.GSTTAXRateIGSTN = 18;
      }

      obj2.Discount = 0;
      obj2.GSTTaxTotal = (obj2.SGSTAmount + obj2.CGSTAmount + obj2.IGSTAmount);
      obj2.TaxableValue = total + obj2.GSTTaxTotal;
      data.product_data.push(obj2);

      //************************************************************** */
      var obj3: any = {};

      obj3.reference_number = a.OrderDetails.ReferenceNo; //ASK
      obj3.delivery_number = null; //ASK
      obj3.product_id = "";
      obj3.product_name = 'OTHERS'; //a.ProductDetails[k].ProductName;
      obj3.product_display_name = a.ProductDetails[k].ProductName;
      obj3.units = a.ProductDetails[k].Qty;
      obj3.unit_type = 'Units'; //a.ProductDetails[k].UnitName;
      obj3.weight = a.ProductDetails[k].ProductWeight;
      obj3.billable_weight = a.ProductDetails[k].VolumetricWeight > a.OrderDetails.Weight == true ? a.ProductDetails[k].VolumetricWeight : a.OrderDetails.Weight;
      obj3.weight_measure = "Kgs";
      obj3.length = a.ProductDetails[k].Length;
      obj3.width = a.ProductDetails[k].Width;
      obj3.height = a.ProductDetails[k].Height;
      obj3.uom = 'inches'; //a.ProductDetails[k].UnitName;
      obj3.hsnno = a.ProductDetails[k].HSNNo;
      obj3.price = a.ProductDetails[k].Price;
      var total = parseFloat(a.ProductDetails[k].Price) * parseFloat(a.ProductDetails[k].Qty);
      if (a.OrderDetails.ConsignerState == a.OrderDetails.ConsigneeState) {
        obj3.SGSTAmount = total * (9 / 100);
        obj3.CGSTAmount = total * (9 / 100);
        obj3.IGSTAmount = 0;
        obj3.GSTTaxRateCGSTN = 9;
        obj3.GSTTaxRateSGSTN = 9;
        obj3.GSTTAXRateIGSTN = 0;
      } else {
        obj3.SGSTAmount = 0;
        obj3.CGSTAmount = 0;
        obj3.IGSTAmount = total * (18 / 100);
        obj3.GSTTaxRateCGSTN = 0;
        obj3.GSTTaxRateSGSTN = 0;
        obj3.GSTTAXRateIGSTN = 18;
      }
      obj3.Discount = 0;
      obj3.GSTTaxTotal = (obj3.SGSTAmount + obj3.CGSTAmount + obj3.IGSTAmount);
      obj3.TaxableValue = total + obj3.GSTTaxTotal;
      data.products.push(obj3);

      var obj4: any = {};

      obj4.reference_number = a.OrderDetails.ReferenceNo; //ASK
      obj4.delivery_number = null; //ASK
      obj4.product_id = "";
      obj4.product_name = 'OTHERS'; //a.ProductDetails[k].ProductName;
      obj4.product_display_name = a.ProductDetails[k].ProductName;
      obj4.units = a.ProductDetails[k].Qty;
      obj4.unit_type = 'Units'; //a.ProductDetails[k].UnitName;
      obj4.weight = a.ProductDetails[k].weight;
      obj4.billable_weight = a.ProductDetails[k].VolumetricWeight > a.OrderDetails.Weight == true ? a.ProductDetails[k].VolumetricWeight : a.OrderDetails.Weight;
      obj4.weight_measure = "Kgs";
      obj4.length = a.ProductDetails[k].Length;
      obj4.width = a.ProductDetails[k].Width;
      obj4.height = a.ProductDetails[k].Height;
      obj4.uom = 'inches'; //a.ProductDetails[k].UnitName;
      obj4.Barcode = a.ProductDetails[k].Barcode;
      obj4.product_code = a.ProductDetails[k].ProductCode;
      obj4.Category = a.ProductDetails[k].Category;
      data.consignment_contents_common.consignment_content_common.push(obj4);
    }

    data.consignment.consignment_invoices = {};
    data.consignment.consignment_invoices.consignment_invoice = [];
    for (let k = 0; k < a.InvoiceDetails.length; k++) {
      var obj: any = {};

      obj.invoice_number = a.InvoiceDetails[k].InvoiceNo;
      obj.delivery_number = null; //ASK
      obj.invoice_value = a.InvoiceDetails[k].Amount;
      obj.invoice_date = a.InvoiceDetails[k].InvoiceDate;
      obj.cod_amount = a.InvoiceDetails[k].Amount;
      obj.weight = a.OrderDetails.Weight;
      obj.billable_weight = a.InvoiceDetails[k].VolumetricWeight > a.OrderDetails.Weight ? a.InvoiceDetails[k].VolumetricWeight : a.OrderDetails.Weight;
      obj.weight_measure = "Kgs";
      obj.pickable_units = a.InvoiceDetails[k].Qty;
      obj.eway_bill_number = a.InvoiceDetails[k].eWayBill;
      obj.eway_bill_expiry_date = a.InvoiceDetails[k].eWayBillExpiryDate;
      data.consignment.consignment_invoices.consignment_invoice.push(obj);
    }

    data.parcellist = [];
    for (let k = 0; k < a.OrdersPackage.length; k++) {
      var obj: any = {};
      obj.weight = a.OrdersPackage[k].GrossWeight;
      obj.length = a.OrdersPackage[k].Length;
      obj.height = a.OrdersPackage[k].Height;
      obj.width = a.OrdersPackage[k].Width;
      obj.item_description = a.OrdersPackage[k].ProductName;
      obj.no_of_items = a.OrdersPackage[k].TotalPackages;
      obj.item_value = a.OrdersPackage[k].InvoiceAmount;
      obj.hscode = a.OrdersPackage[k].HSNNo;
      data.parcellist.push(obj);
    }

    data.consignment.service_provider_id = "";
    data.consignment.service_provider_name = "";
    data.consignment.service_provider_code = "";
    data.consignment.consignment_type = "OUTBOUND-TBB";
    data.OrderId = OrderId;
    data.TransporterId = TransporterId;
    data.PickUpDateTime = a.OrderDetails.PickupDate;
    data.consignor_email = a.OrderDetails.PickUpContactEmail;
    data.consignee_email = a.OrderDetails.DeliveryContactEmail;
    data.consignor_lat = a.OrderDetails.PickUpLatitude;
    data.consignor_long = a.OrderDetails.PickUpLongtitude;
    data.consignee_lat = a.OrderDetails.DeliverLatitude;
    data.consignee_long = a.OrderDetails.DeliverLongtitude;
    data.tax_id = a.OrderDetails.PickupGSTNo;
    data.consignor_country = a.OrderDetails.PickupCountry;
    data.consignee_country = a.OrderDetails.DeliveryCountry;
    data.VolumetricWeight = a.OrderDetails.VolumetricWeight;
    data.PickupDateV2 = a.OrderDetails.PickupDateV2;

    data.Customer = {};
    data.Customer.CustomerAddress1 = a.OrderDetails.CustomerAddress;
    data.Customer.CustomerAddress2 = "";
    data.Customer.CustomerAddress3 = "";
    data.Customer.CustomerEmailID = a.OrderDetails.CustomerMail;
    data.Customer.CustomerGSTNumber = a.OrderDetails.CustomeGST;
    data.Customer.CustomerLatitude = "";
    data.Customer.CustomerLongitude = "";
    data.Customer.CustomerMobile = a.OrderDetails.CustomerMobile;
    data.Customer.CustomerName = a.OrderDetails.CustomerName;
    data.Customer.CustomerPincode = a.OrderDetails.CustomerPincode;
    data.service_code = service_code;

    Helpers.setLoading(true);
    await new Promise(async (resolve1, reject1) => {
      this._appService
        .Post("OrdersByVehicle", "CreateConsignment", data)
        .subscribe(
          async (response) => {
            Helpers.setLoading(false);

            if (response.isScuccess == true) {
              this.toastr.success(
                this.translate.instant("ALERTMESSAGES.ConsignmentSuccess"),
                "Success"
              );

              var ShipmentId, ShipmentNo = '';
              if (TransporterName == "Smart Track") {
                var msg = JSON.parse(response.message);
                ShipmentId = msg['data']['shipment_id'];
                ShipmentNo = msg['data']['shipment_number'];
              }

              Helpers.setLoading(true);
              this._appService
                .GetByEightId(
                  "OrdersByVehicle",
                  "oc_ConfirmCourierData_generateInvoiceOrderWiseV2",
                  OrderId,
                  this.userId,
                  TransporterId,
                  LeadTime,
                  ShipmentId,
                  ShipmentNo,
                  service_code,
                  TotalRate
                )
                .subscribe(
                  async (response) => {
                    Helpers.setLoading(false);
                    if (response[0].isDone == "OK") {
                      this.toastr.success(
                        "Order Confirm successfully !",
                        "Success"
                      );

                      resolve1("Ok");
                      setTimeout(() => {
                        if (this.TransationType == "Air") {
                          window.location.href = '/NewBookingList';
                          // this.router.navigateByUrl(`/NewBookingList`);
                        } else {
                          this.router.navigateByUrl(`/FtlList`);
                        }
                      }, 1000);
                      Helpers.setLoading(false);
                    } else {
                      this.toastr.success(
                        "Error Occurred While ConFirm Booking !",
                        "Error"
                      );
                      Helpers.setLoading(false);
                      resolve1("Ok");
                    }
                    if (response[0].invoiceResult != "Success") {
                      this.toastr.success(
                        "Error Occurred While Generating Shipment !",
                        "Error"
                      );
                      Helpers.setLoading(false);
                      resolve1("Ok");
                    }
                  },
                  (err) => {
                    Helpers.setLoading(false);
                    this.toastr.error(err._body.replace(/"/g, ""), "Error");
                    resolve1("Ok");
                  }
                );
            } else {
              var msg = JSON.parse(response.message);

              if (TransporterName == "V-Xpress")
                this.toastr.error(msg.exception.message, "Error");

              if (
                TransporterName == "Delhivery" ||
                TransporterName == "OM Logistics"
              )
                this.toastr.error(msg.message, "Error");

              if (TransporterName == "XpressBees")
                this.toastr.error(msg.ReturnMessage, "Error");

              if (TransporterName == "Allcargo GATI") {
                // this.toastr.error(msg['meta']['message'], 'Error');
                const detailsArray = msg["meta"]["details"][0];
                if (!detailsArray.includes("{")) {
                  this.toastr.error(detailsArray, "Error", {
                    enableHtml: true,
                  });
                } else {
                  const validJsonString = detailsArray.replace(/'/g, '"');
                  const detailsObject = JSON.parse(validJsonString);
                  let toastrMessage = "";

                  // Loop through details and format message
                  for (const key in detailsObject) {
                    if (detailsObject.hasOwnProperty(key)) {
                      const nestedObject = detailsObject[key];
                      for (const nestedKey in nestedObject) {
                        if (nestedObject.hasOwnProperty(nestedKey)) {
                          const errors = nestedObject[nestedKey];
                          if (Array.isArray(errors)) {
                            // If errors is an array, iterate over each error
                            errors.forEach((error: string) => {
                              toastrMessage += `${nestedKey}: ${error}<br>`;
                            });
                          } else if (typeof errors === "object") {
                            // If errors is an object, assume it has message arrays
                            for (const prop in errors) {
                              if (
                                errors.hasOwnProperty(prop) &&
                                Array.isArray(errors[prop])
                              ) {
                                errors[prop].forEach((error: string) => {
                                  toastrMessage += `${prop}: ${error}<br>`;
                                });
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  // Show toastr message
                  this.toastr.error(toastrMessage, "Error", {
                    enableHtml: true,
                  });
                }
              }

              if (TransporterName == 'Smart Track') {
                this.toastr.error(msg.errors[0], 'Error');
              }

              Helpers.setLoading(false);
            }
            console.log(response);
          },
          (err) => {
            console.log(err);
            // this.toastr.error(err._body.replace(/"/g, ""), "Error");
            Helpers.setLoading(false);
          }
        );
    });
  }

  CreateConsignmentCountry(TransporterId, LeadTime) {
    Helpers.setLoading(true);
    this._appService.GetByEightId("OrdersByVehicle","oc_ConfirmCourierData_generateInvoiceOrderWiseV2",this.Id,this.userId,TransporterId,LeadTime,'','','',0).subscribe(
    (response) => {
      if (response[0].isDone == "OK") {
        this.toastr.success("Order Confirm successfully !", "Success");
        Helpers.setLoading(false);
        this.router.navigateByUrl("/NewBookingList");
      } else {
        this.toastr.error(
          "Error Occurred While ConFirm Booking !",
          "Error"
        );
        Helpers.setLoading(false);
      }
    },
    (err) => {
      Helpers.setLoading(false);
      this.toastr.error(err._body.replace(/"/g, ""), "Error");
    });
  }

}

